// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__3V3Ql","active":"MenuItem_active__P-h0Q"};